/**
 * package: com.inq.flash.messagingframework.connectionhandling
 * class: ConnectionHandler
 * root Object
 * @constructor
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler = function() {};
$hxClasses['com.inq.flash.messagingframework.connectionhandling.ConnectionHandler'] = com.inq.flash.messagingframework.connectionhandling.ConnectionHandler;
/** @private @type {Array} */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.__name__ = ["com","inq","flash","messagingframework","connectionhandling","ConnectionHandler"];

/**
 * acknowledgePersistentActive
 *
 * $type TFun([{ name => chatID, t => TInst(String,[]), opt => false },{ name => protoDomain, t => TInst(String,[]), opt => false },{ name => clientProtoDomain, t => TInst(String,[]), opt => false },{ name => needNewOpener, t => TEnum(Bool,[]), opt => false },{ name => messageCnt, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function acknowledgePersistentActive(chatID:String, protoDomain:String, clientProtoDomain:String, needNewOpener:Bool, messageCnt:String):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @param {string}  chatID 
 * @param {string}  protoDomain 
 * @param {string}  clientProtoDomain 
 * @param {boolean}  needNewOpener 
 * @param {string}  messageCnt 
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.acknowledgePersistentActive = null;

/**
 * acknowledgeChatActive
 *
 * $type TFun([{ name => chatID, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function acknowledgeChatActive(chatID:String):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @param {string}  chatID 
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.acknowledgeChatActive = null;

/**
 * enable
 *
 * $type TFun([],TEnum(Void,[]))
 * public function enable():Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.enable = null;

/**
 * disable
 *
 * $type TFun([],TEnum(Void,[]))
 * public function disable():Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.disable = null;

/**
 * getConnectionType
 *
 * $type TFun([],TInst(String,[]))
 * function getConnectionType():String
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @return {string}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.getConnectionType = null;

/**
 * sendMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * function sendMessage(message:Message):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.sendMessage = null;

/**
 * isConnected
 *
 * $type TFun([],TEnum(Bool,[]))
 * function isConnected():Bool
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @return {boolean}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.isConnected = null;

/**
 * disconnect
 *
 * $type TFun([],TEnum(Void,[]))
 * function disconnect():Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.disconnect = null;

/**
 * connect
 *
 * $type TFun([],TEnum(Void,[]))
 * function connect():Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.connect = null;

/**
 * setParam
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false },{ name => valu, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * function setParam(name:String,valu:Dynamic):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @param {string}  name 
 * @param {null}  valu 
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.setParam = null;

/**
 * setHost
 *
 * $type TFun([{ name => host, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * function setHost(host:String):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @param {string}  host 
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.setHost = null;

/**
 * setApplicationConnectionEventHandler
 *
 * $type TFun([{ name => applicationConnectionEventHandler, t => TInst(com.inq.flash.messagingframework.connectionhandling.ApplicationConnectionEventHandler,[]), opt => false }],TEnum(Void,[]))
 * function setApplicationConnectionEventHandler(applicationConnectionEventHandler:ApplicationConnectionEventHandler):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @param {com.inq.flash.messagingframework.connectionhandling.ApplicationConnectionEventHandler}  applicationConnectionEventHandler 
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.setApplicationConnectionEventHandler = null;

/**
 * setMessagingFramework
 *
 * $type TFun([{ name => framework, t => TInst(com.inq.flash.messagingframework.FlashMessagingFramework,[]), opt => false }],TEnum(Void,[]))
 * function setMessagingFramework(framework:FlashMessagingFramework):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @param {com.inq.flash.messagingframework.FlashMessagingFramework}  framework 
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.setMessagingFramework = null;

/**
 * setMessageRouter
 *
 * $type TFun([{ name => messageRouter, t => TInst(com.inq.flash.messagingframework.MessageRouter,[]), opt => false }],TEnum(Void,[]))
 * function setMessageRouter(messageRouter:MessageRouter):Void
 * @public
 * @this com.inq.flash.messagingframework.connectionhandling.ConnectionHandler
 * @param {com.inq.flash.messagingframework.MessageRouter}  messageRouter 
 * @return {void}
 */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.setMessageRouter = null;
/** @type {com.inq.flash.messagingframework.connectionhandling.ConnectionHandler} */
com.inq.flash.messagingframework.connectionhandling.ConnectionHandler.prototype.__class__ = com.inq.flash.messagingframework.connectionhandling.ConnectionHandler;
